import { createContext, useContext } from "react";

/**
 * FieldPath
 * ---------
 * react-hook-form counterpart of a nested react-reactive-form `FieldGroup`:
 * inputs rendered inside `<FieldPath name="address">` bind to
 * `address.<id>`. Paths nest, e.g. `<FieldPath name="other.0">`.
 */
const FieldPathContext = createContext("");

export const joinPath = (...parts) => parts.filter((p) => p !== "" && p != null).join(".");

export const FieldPath = ({ name, children }) => {
  const parent = useContext(FieldPathContext);
  return (
    <FieldPathContext.Provider value={joinPath(parent, name)}>
      {children}
    </FieldPathContext.Provider>
  );
};

/** Current path prefix ("" at the form root). */
export const useFieldPrefix = () => useContext(FieldPathContext);

/** Full react-hook-form name for a field id inside the current FieldPath. */
export const useFieldName = (name) => joinPath(useFieldPrefix(), name);
